import React from 'react';

/**
 * Versión compacta del widget de Efectividad de la Entrega para usar en listados.
 * Muestra solo una barra de progreso pequeña con porcentaje y tiempo restante.
 */
const TiempoProcesamientoWidgetCompact = ({ efectividad }) => {
  // Si no hay datos de efectividad, no mostrar nada
  if (!efectividad) {
    return <span className="text-muted">-</span>;
  }

  const { porcentaje, color, tiempo_restante_texto } = efectividad;

  // Mapear colores del backend a clases de Bootstrap
  const getColorClass = () => {
    if (color === "success") return "bg-success";
    if (color === "warning") return "bg-warning";
    if (color === "danger") return "bg-danger";
    return "bg-primary";
  };

  return (
    <div className="efectividad-compact d-flex flex-column gap-1" style={{ minWidth: '120px' }}>
      {/* Barra de progreso */}
      <div className="progress" style={{ height: '8px' }}>
        <div
          className={`progress-bar ${getColorClass()}`}
          role="progressbar"
          style={{ width: `${Math.min(100, porcentaje)}%` }}
          aria-valuenow={porcentaje}
          aria-valuemin="0"
          aria-valuemax="100"
        />
      </div>
      
      {/* Texto con porcentaje y tiempo restante */}
      <div className="d-flex justify-content-between align-items-center">
        <small className="text-muted fw-medium">{Math.round(porcentaje)}%</small>
        <small className="text-muted">{tiempo_restante_texto}</small>
      </div>
    </div>
  );
};

export default TiempoProcesamientoWidgetCompact;
